import { render } from "./SolicitacaoVisitaView.vue?vue&type=template&id=cf8f96ec&scoped=true"
import script from "./SolicitacaoVisitaView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoVisitaView.vue?vue&type=script&lang=js"

import "./SolicitacaoVisitaView.vue?vue&type=style&index=0&id=cf8f96ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8f96ec"]])

export default __exports__